import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "admin-proxy-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Admin Proxy", -1 /* HOISTED */)
const _hoisted_3 = { class: "proxy-user-list" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "proxy-user-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    ($setup.loading)
      ? (_openBlock(), _createBlock($setup["Loader"], {
          key: 0,
          "full-screen": true
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.users, (user) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "proxy-user",
                onClick: ($event: any) => ($setup.showConfirmFor = user)
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(user.name.fullName), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_4))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          ($setup.showConfirmFor)
            ? (_openBlock(), _createBlock($setup["SimpleYesNoModal"], {
                key: 0,
                onClose: _cache[0] || (_cache[0] = ($event: any) => ($setup.showConfirmFor = null)),
                onYes: _cache[1] || (_cache[1] = ($event: any) => ($setup.performProxy($setup.showConfirmFor!)))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, "Are you sure you want to proxy into " + _toDisplayString($setup.showConfirmFor.name.fullName) + "'s account?", 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }))
            : _createCommentVNode("v-if", true)
        ], 64 /* STABLE_FRAGMENT */))
  ]))
}